import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
	selector: 'app-new-email-info-modal',
	templateUrl: './new-email-info-modal.component.html',
	styleUrls: ['./new-email-info-modal.component.scss'],
})
export class NewEmailInfoModalComponent implements OnInit, AfterViewInit {
	@ViewChild('paragraph2', { static: false }) paragraph2!: ElementRef;

	constructor(
		private navService: NavigationService,
		private renderer: Renderer2,
		private translate: TranslateService,
		public dialogRef: MatDialogRef<NewEmailInfoModalComponent>
	) {}

	ngOnInit() {}
	ngAfterViewInit(): void {
		this.translate.onLangChange.subscribe(() => {
			this.addClickListener();
		});

		setTimeout(() => this.addClickListener(), 0);
	}

	addClickListener(): void {
		if (!this.paragraph2?.nativeElement) return;

		const linkEl = this.paragraph2.nativeElement.querySelector('.link');
		if (linkEl) {
			this.renderer.listen(linkEl, 'click', (event: Event) => {
				event.preventDefault();
				this.toForgotPassword();
			});
		}
	}

	close() {
		this.dialogRef.close();
	}

	toForgotPassword() {
		this.dialogRef.close();
		this.navService.forgotPassword();
	}

	goToExternalLink() {
		const url = 'https://frlosteria.sharepoint.com/:b:/t/Communication/EZizioPmfaxJv1pSBW9e4DYB7A0ij5cJk9_QAlsbaj8emA?e=yzgNno';
		window.open(url, '_blank');
	}

	static open(dialog: MatDialog) {
		dialog.open(NewEmailInfoModalComponent);
	}
}
